<template>
    <v-card @mouseover="hover = true" @mouseleave="hover = false"
            :class="hover ? 'elevation-10 mb-2': 'elevation-2 mb-2'">
        <v-container fill-height fluid class="pa-0" grid-list-md>
            <v-layout row wrap fill-height>
                <v-flex xs12 sm5 lg4>
                    <div class="data primary white--text pa-2" style="height:100%;">
                        <div class="confirmation">
                            <div class="confi-state">
                                <v-icon class="confi-icon primary--text">{{ confirmation.icon }}</v-icon>
                            </div>
                            <p class="confi-text">{{ confirmation.text }}</p>
                        </div>
                        <p>{{ $moment(date).format('dddd') | capitalize }}</p>
                        <p style="font-size:25px;margin-top:-7px;">{{ $moment(date).format('DD MMM') }}</p>
                        <!-- <v-divider class="white mt-2"></v-divider> -->
                        <p style="font-size:45px;margin-top:-15px;">{{ time }}</p>
                    </div>
                </v-flex>
                <v-flex xs12 sm7 lg8 class="text-xs-right data">
                    <div class="pa-2 mb-4 pr-4">
                        <p>{{ service }}</p>
                        <p style="font-size:27px;margin-top:-8px;" class="primary--text">{{ serviceItem }}</p>
                        <p style="font-size:11px;margin-top:-5px;"><span class="primary--text">Solicitada el:</span>
                            {{ $moment(reserved).format('DD MMM HH:mm') }}</p>
                    </div>
                    <div class="pa-2 pr-4">
                        <v-divider class="mt-4 mb-2"></v-divider>
                        <p style="font-size:21px;">{{ provider }}</p>
                        <p style="font-size:11px;min-height:38px;">{{ address }}</p>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
    </v-card>
</template>
<script>
export default {
    props: {
        reserved: {
            type: String,
            default: new Date().toString()
        },
        created: {
            type: String,
            default: new Date().toString()
        },
        date: {
            type: String,
            default: '2020-01-01'
        },
        time: {
            type: String,
            default: '12:00'
        },
        confirmed: {
            type: Boolean,
            default: false
        },
        service: {
            type: String,
            default: 'No Service'
        },
        serviceItem: {
            type: String,
            default: 'No Service Item'
        },
        provider: {
            type: String,
            default: 'No Provider'
        },
        address: {
            type: String,
            default: 'No Address'
        }
    },
    data() {
        return {
            hover: false
        }
    },
    computed: {
        confirmation() {
            if (this.confirmed)
                return {
                    text: 'CONFIRMADA',
                    icon: 'fas fa-check'
                }
            return {
                text: 'POR CONFIRMAR',
                icon: 'far fa-hourglass'
            }
        }
    }
}
</script>
<style scoped>
.data p {
    margin: 0;
}

.confirmation {
    text-align: right;
    padding-right: 6px;
    border: 1px solid white;
    margin-bottom: 13px;
    position: relative;
    max-width: 110px;
}

.confi-text {
    font-size: 9px;
    padding: 2px 0;
}

.confi-state {
    background-color: white;
    width: 25px;
    height: 25px;
    position: absolute;
    border-radius: 100%;
    left: -5px;
    top: 50%;
    transform: translateY(-50%);
}

.confi-icon {
    font-size: 15px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    left: 50%;

}
</style>